import React, { memo } from 'react';
import PropTypes from 'prop-types';

import { BodyRow, DateCell } from './styles';

const CurrencyYearArchiveRatesTableDays = memo(
  ({ days, formatDayLabel, renderRateCells, highlightedDate }) => (
    <>
      {(days || []).map((day, index) => {
        const dayDate = String(day.date).slice(0, 10);

        return (
          <BodyRow
            key={day.date}
            data-date={dayDate}
            $isEven={index % 2 === 1}
            $isHighlighted={highlightedDate === dayDate}
          >
            <DateCell>
              <time dateTime={dayDate}>{formatDayLabel(day.date)}</time>
            </DateCell>
            {renderRateCells(day)}
          </BodyRow>
        );
      })}
    </>
  )
);

CurrencyYearArchiveRatesTableDays.propTypes = {
  days: PropTypes.arrayOf(PropTypes.object),
  formatDayLabel: PropTypes.func.isRequired,
  renderRateCells: PropTypes.func.isRequired,
  highlightedDate: PropTypes.string,
};

CurrencyYearArchiveRatesTableDays.defaultProps = {
  days: [],
  highlightedDate: null,
};

export default CurrencyYearArchiveRatesTableDays;
